"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationHttpClient = void 0;
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
class NotificationHttpClient extends BaseClient_1.BaseClient {
    async removeSubscription(identity, subscription) {
        this.removeSocketIoSubscription(identity, subscription);
    }
    onConnected(callback, subscribeOnce) {
        return this.createSocketIoSubscription('connect', callback, subscribeOnce);
    }
    onDisconnected(callback, subscribeOnce) {
        return this.createSocketIoSubscription('disconnect', callback, subscribeOnce);
    }
    onReconnected(callback, subscribeOnce) {
        return this.createSocketIoSubscription('reconnect', callback, subscribeOnce);
    }
    async onProcessDeployed(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.processDeployed, callback, subscribeOnce, identity);
    }
    async onProcessUndeployed(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.processUndeployed, callback, subscribeOnce, identity);
    }
    async onProcessIsExecutableChanged(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.processExecutableChanged, callback, subscribeOnce, identity);
    }
    async onProcessStarting(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.processStarting, callback, subscribeOnce, identity);
    }
    async onProcessStarted(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.processStarted, callback, subscribeOnce, identity);
    }
    async onProcessResumed(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.processResumed, callback, subscribeOnce, identity);
    }
    async onProcessEnded(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.processEnded, callback, subscribeOnce, identity);
    }
    async onProcessTerminated(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.processTerminated, callback, subscribeOnce, identity);
    }
    async onProcessError(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.processError, callback, subscribeOnce, identity);
    }
    async onProcessInstancesDeleted(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.processInstancesDeleted, callback, subscribeOnce, identity);
    }
    async onCronjobCreated(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.cronjobCreated, callback, subscribeOnce, identity);
    }
    async onCronjobStopped(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.cronjobStopped, callback, subscribeOnce, identity);
    }
    async onCronjobUpdated(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.cronjobUpdated, callback, subscribeOnce, identity);
    }
    async onCronjobExecuted(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.cronjobExecuted, callback, subscribeOnce, identity);
    }
    async onCronjobRemoved(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.cronjobRemoved, callback, subscribeOnce, identity);
    }
    async onActivityReached(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.activityReached, callback, subscribeOnce, identity);
    }
    async onActivityFinished(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.activityFinished, callback, subscribeOnce, identity);
    }
    async onEmptyActivityWaiting(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.emptyActivityWaiting, callback, subscribeOnce, identity);
    }
    async onEmptyActivityFinished(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.emptyActivityFinished, callback, subscribeOnce, identity);
    }
    async onManualTaskWaiting(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.manualTaskWaiting, callback, subscribeOnce, identity);
    }
    async onManualTaskFinished(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.manualTaskFinished, callback, subscribeOnce, identity);
    }
    async onUserTaskWaiting(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.userTaskWaiting, callback, subscribeOnce, identity);
    }
    async onUserTaskFinished(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.userTaskFinished, callback, subscribeOnce, identity);
    }
    async onUserTaskReserved(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.userTaskReserved, callback, subscribeOnce, identity);
    }
    async onUserTaskReservationCanceled(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.userTaskReservationCanceled, callback, subscribeOnce, identity);
    }
    async onBoundaryEventTriggered(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.boundaryEventTriggered, callback, subscribeOnce, identity);
    }
    async onIntermediateThrowEventTriggered(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.intermediateThrowEventTriggered, callback, subscribeOnce, identity);
    }
    async onIntermediateCatchEventReached(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.intermediateCatchEventReached, callback, subscribeOnce, identity);
    }
    async onIntermediateCatchEventFinished(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.intermediateCatchEventFinished, callback, subscribeOnce, identity);
    }
    async onExternalTaskCreated(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.externalTaskCreated, callback, subscribeOnce, identity);
    }
    async onExternalTaskLocked(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.externalTaskLocked, callback, subscribeOnce, identity);
    }
    async onExternalTaskUnlocked(callback, subscribeOnce, identity) {
        return this.createSocketIoSubscription(index_1.socketSettings.paths.externalTaskUnlocked, callback, subscribeOnce, identity);
    }
}
exports.NotificationHttpClient = NotificationHttpClient;
//# sourceMappingURL=NotificationHttpClient.js.map